// extracted by mini-css-extract-plugin
module.exports = {"list":"Navigation_list__3sSNp","item":"Navigation_item__3GTsR","link":"Navigation_link__1KVK8"};